import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, PhoneCall } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  const words = ['Education', 'Healthcare', 'Commercial', 'Industrial', 'Events'];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % words.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div className="relative min-h-[80vh] flex items-center overflow-hidden bg-brand-dark" data-id="element-154">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-155">
        <img src="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-Fleet.webp" alt="Rapid Energy Fleet" className="w-full h-full object-cover opacity-30" data-id="element-156" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark via-brand-dark/80 to-transparent" data-id="element-157"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-158">
        <div className="max-w-3xl" data-id="element-159">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-160">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-white/20" data-id="element-161">
              <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-162"></span>
              <span className="text-white text-sm font-medium tracking-wide uppercase" data-id="element-163">
                Nationwide 24/7 Emergency Response
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-heading font-extrabold text-white leading-tight mb-6" data-id="element-164">
              Boiler Hire for: <br data-id="element-165" />
              <span className="text-brand-green inline-block min-w-[300px]" data-id="element-166">
                <AnimatePresence mode="wait" data-id="element-167">
                  <motion.span key={index} initial={{
                  y: 20,
                  opacity: 0
                }} animate={{
                  y: 0,
                  opacity: 1
                }} exit={{
                  y: -20,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} className="inline-block" data-id="element-168">
                    {words[index]}
                  </motion.span>
                </AnimatePresence>
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl leading-relaxed" data-id="element-169">
              Your critical asset hire partner providing high-end, efficient
              temporary heating and cooling solutions across the UK.
            </p>

            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-170">
              <Link to="/services" className="inline-flex justify-center items-center px-8 py-4 bg-brand-green text-brand-dark font-bold rounded-md hover:bg-white transition-colors duration-300 group" data-id="element-171">
                BOILER HIRE
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-172" />
              </Link>
              <Link to="/contact" className="inline-flex justify-center items-center px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-md hover:bg-white hover:text-brand-dark transition-colors duration-300 group" data-id="element-173">
                <PhoneCall className="mr-2 w-5 h-5" data-id="element-174" />
                REQUEST CALLBACK
              </Link>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-white to-transparent z-10" data-id="element-175"></div>
    </div>;
}